export enum PronexusPermissions {
  PronexusService = 'pronexus-service',
  PronexusOutgoingService = 'pronexus-service-outgoing-log',
  PronexusIncomingService = 'pronexus-service-incoming-log',
}
